<template>
    <div class="section">
        <div class="anchor" id="booth"></div>
        <img src="@/assets/images/title_01.png" alt="" class="title center title-booth">
        <div class="sec-booth">
            <transition name="fade">
                <img v-if="map" :src="map ? require(`@/assets/images/bg1_${ map }.jpg`) : null" alt="" class="pos bg off-1024">
            </transition>

            <div class="sec-box box-map" @mouseleave="selectMap('')">
                <div class="box">
                    <img src="@/assets/images/booth_light.png" alt="">
                    <img class="pos dot" src="@/assets/images/dot.png" alt="" usemap="#map">
                    <img v-show="map !== 'left'" class="pos left" src="@/assets/images/booth_01.png" alt="">
                    <img v-show="map !== 'bottom'" class="pos bottom" src="@/assets/images/booth_02.png" alt="">
                    <img v-show="map !== 'right'" class="pos right" src="@/assets/images/booth_03.png" alt="">
                    <img v-show="map !== 'top'" class="pos top" src="@/assets/images/booth_04.png" alt="">
                    <map name="map" id="map">
                        <area @mouseenter="selectMap('top')" alt="" title="" shape="poly" coords="93,0,739,1,764,78,735,133,649,135,651,157,543,195,436,216,399,216,295,197,98,136,70,77" />
                        <area @mouseenter="selectMap('right')" alt="" title="" shape="poly" coords="518,227,767,165,821,321,798,348,833,492" />
                        <area @mouseenter="selectMap('bottom')" alt="" title="" shape="poly" coords="798,537,38,536,354,256,477,255" />
                        <area @mouseenter="selectMap('left')" alt="" title="" shape="poly" coords="319,225,2,490,33,348,15,324,64,168" />
                    </map>
                    <router-link @mouseenter.native="selectMap('top')" to="/booth/7" class="pin pin1">管弦乐器</router-link>
                    <router-link @mouseenter.native="selectMap('top')" to="/booth/8" class="pin pin2">主舞台</router-link>
                    <router-link @mouseenter.native="selectMap('top')" to="/booth/9" class="pin pin3">无人乐队</router-link>
                    <router-link @mouseenter.native="selectMap('top')" to="/booth/11" class="pin pin4">HIFI体验区</router-link>
                    <router-link @mouseenter.native="selectMap('top')" to="/booth/12" class="pin pin42">高端钢琴智慧展厅</router-link>

                    <router-link to="/booth/10" class="pin pin5" @mouseenter.native="selectMap('right')">电声乐器</router-link>

                    <router-link to="/booth/6" class="pin pin6" @mouseenter.native="selectMap('bottom')">钢琴AI舞台</router-link>
                    <router-link to="/booth/4" class="pin pin7" @mouseenter.native="selectMap('bottom')">钢琴</router-link>
                    <router-link to="/booth/1" class="pin pin8" @mouseenter.native="selectMap('bottom')">前台</router-link>
                    <router-link to="/booth/5" class="pin pin9" @mouseenter.native="selectMap('bottom')">概念乐器展示</router-link>

                    <router-link to="/booth/3" class="pin pin10" @mouseenter.native="selectMap('left')">电子键盘</router-link>
                    <router-link to="/booth/2" class="pin pin11" @mouseenter.native="selectMap('left')">Yamaha Day</router-link>
                </div>
            </div>
            <div class="hint on-1024">
                <i class="remixicon-drag-move-fill"></i>
                滑动展区查看更多
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'SecBooth',
    data() {
        return {
            map: ''
        }
    },
    methods: {
        selectMap(map) {
            if (this.map !== map) this.map = ''
            setTimeout(() => this.map = map, 0)
        },
        // selectStage(stage) {
        //     if (['wind', 'stage', 'band', 'HIFI'].includes(stage)) {
        //         this.map = 'top'
        //     } else if (['ekb2'].includes(stage)) {
        //         this.map = 'right'
        //     } else if (['pianoai', 'piano', 'concept'].includes(stage)) {
        //         this.map = 'bottom'
        //     } else if (['ekb', 'day'].includes(stage)) {
        //         this.map = 'left'
        //     }
        //     this.stage = stage
        // }
    },
    computed: {
    }
}
</script>

<style lang="scss" scoped>
@import "../styles/components/variable.scss";

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.box-map {
    max-width: none;

    .box {
        width: 834px;
        margin: 0 auto;
        position: relative;
    }

    img {
        // max-width: 100%;
    }

    .dot {
        width: 100%;
        height: 100%;
        z-index: 1;
    }
}

.pos {
    position: absolute;
    top: 0;
    left: 0;
}

.sec-booth {
    position: relative;
    display: flex;
    align-items: center;
    transition: all 4s ease;
    background-repeat: no-repeat;
    background-image: none;
    
    padding: 3% 7%;
    overflow-y: hidden;
}

.pin {
    display: flex;
    position: absolute;
    width: 125px;
    height: 50px;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    color: #000;
    border-radius: 5px;
    font-size: 16px;
    cursor: pointer;
    z-index: 2;

    &:hover {
        background-color: $purple;
        color: #fff;

        &::after {
            border-color: $purple transparent transparent transparent;
        }
    }

    &::after {
        content: "";
        display: block;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 10px 12.5px 0 12.5px;
        border-color: #ffffff transparent transparent transparent;
        position: absolute;
        bottom: -9px;
        left: 50%;
        transform: translateX(-50%);
    }
}

.pin1 {
    top: 0;
    left: 14%;
}

.pin2 {
    top: 12%;
    left: 43%;
}

.pin3 {
    top: 15%;
    left: 63%;
}

.pin4 {
    top: 3%;
    right: 3%;
}

.pin42 {
    width: 155px;
    top: 0%;
    right: 20%;
}

.pin5 {
    top: 37%;
    right: 10%;
}

.pin6 {
    left: 43%;
    bottom: 50%;
}

.pin7 {
    bottom: 34%;
    left: 25%;
}

.pin8 {
    bottom: 10%;
    left: 10%;
}

.pin9 {
    left: 43%;
    bottom: 23%;
}

.pin10 {
    top: 34%;
    left: 10%;
}

.pin11 {
    top: 60%;
    left: 0%;
}


@media all and (max-width: 1024px) {

.sec-booth {
    flex-wrap: wrap;
    padding: 0;
    
}

.box-map {
    // width: 600px;
    overflow-x: scroll;

    .box {
        transform: scale(0.7);
        margin: -20% -20%;
    }
}

.hint {
    width: 100%;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 4%;
    // margin-top: -26%;
    text-align: center;
    font-size: 2.5vw;
    color: #888;

    i {
        margin-right: 6px;
    }
}

}
</style>